module.exports = __webpack_public_path__ + "img/icon-union.dc1d1dc4.svg";